
/* injects from baggage-loader */

import {CURRENT_USER} from 'redux/modules/currentUser'
import loadTypes from 'utils/loadTypes'

export const STORE_WIZARD_DATA = 'STORE_WIZARD_DATA'
export const CLEAR_STORAGE = loadTypes('CLEAR_STORAGE')
export const GET_STORAGE = loadTypes('GET_STORAGE')

const initialState = {
  active: false,
  edit: false,
  steps: [
    {id: 'siteCreation', active: true},
    {id: 'marketingChannels'},
    {id: 'mappings'},
    {id: 'installation'}
  ]
}

export default function wizard(state = initialState, action) {
  switch (action.type) {
    case CURRENT_USER.SUCCESS:
      const storage = (action.response.storage && action.response.storage.wizard) || {}
      return {
        ...state,
        active: storage.active,
        edit: storage.edit,
        steps: storage.steps || state.steps
      }

    case STORE_WIZARD_DATA:
      if (action.data) {
        const {active, steps, edit} = action.data
        return {
          ...state,
          active,
          edit,
          steps
        }
      } else {
        return {
          ...initialState,
          steps: initialState.steps
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/wizard/index.js